<ion-header>
  <ion-toolbar style="width: 100%;">
    <div class="title-content">
      <h3>Reply Address</h3>
    </div>
  </ion-toolbar>
</ion-header>
<div class="message-avatar">
  <div class="icon-circle">
    <div class="inner-circle">
      <ion-icon name="paper-plane" size="large"></ion-icon>
    </div>
  </div>
</div>
<ion-content #scrollContent>
  <div class="bg-notebook-paper">
    <div (ngSubmit)="onSaveAndContinue()">
      <h2 class="form-title" *ngIf="!addressConfirmation">Where would you like your reply sent?</h2>
      <h2 class="form-title" *ngIf="addressConfirmation">Address Verification</h2>
      <p class="form-title" *ngIf="addressConfirmation">
        We were unable to verify your return address. Please confirm the details below: 
    </p>

      <div id="main-content" #mainContent>
        <ion-list class="address-fields" [class.submitted]="formSubmitted" no-lines>
          <app-stripe-address 
            *ngIf="isAddressDataReady" 
            #stripeAddress
            [debounceTime]="300"
            [defaultAddress]="currentMessage.returnAddress.address_line1 ? currentMessage.returnAddress : currentMessage.defaultReturnAddress || {}"
            (addressChange)="onAddressChanged($event)">
          </app-stripe-address>
        </ion-list>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer id="modal-footer">
  <div id="message-actions">
    <ion-grid>
      <ion-row>
        <ion-col col-6 class="back">
          <ion-button ion-button (click)="onCancel()" icon-left>
            <div class="button-inner">
              <ion-icon name="arrow-back"></ion-icon>
              Back
            </div>
          </ion-button>
        </ion-col>
        <ion-col col-6 class="continue">
          <ion-button ion-button icon-right (click)="onSaveAndContinue()">
            <div class="button-inner">
              Continue
              <ion-icon name="arrow-forward"></ion-icon>
            </div>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-footer>
